module.exports = __webpack_public_path__ + "img/qostanay4.80ad4683.jpg";